// extracted by mini-css-extract-plugin
export var addButton = "_fe-0";
export var border = "_fe-8";
export var check = "_fe-h";
export var danger = "_fe-6";
export var dropdownContainer = "_fe-1";
export var editModalBody = "_fe-j";
export var footerContainer = "_fe-i";
export var fullWidth = "_fe-a";
export var hide = "_fe-9";
export var icon = "_fe-3";
export var input = "_fe-7";
export var inputFlex = "_fe-b";
export var inputWrapper = "_fe-c";
export var manualFocus = "_fe-5";
export var optionButton = "_fe-4";
export var pillWrapper = "_fe-e";
export var pointer = "_fe-2";
export var showOverflow = "_fe-f";
export var tagsFlex = "_fe-d";
export var xButton = "_fe-g";